import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import featureFlag from './plugins/featureFlag';
import { loadFonts } from './plugins/webfontloader';
import Notifications from '@kyvg/vue3-notification';

loadFonts();

const app = createApp(App);

app.use(router);
app.use(store);
app.use(vuetify);
app.use(Notifications);
app.use(featureFlag);

router.isReady().then(() => {
  app.mount('#app');
});
